import { render, staticRenderFns } from "./IntegrationManagement.vue?vue&type=template&id=05f6d710&"
import script from "./IntegrationManagement.vue?vue&type=script&lang=js&"
export * from "./IntegrationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports